import React from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import PropTypes from "prop-types";
import bg from "../../assets/images/HeaderDocument.jpg";
import sign_inno from "../../assets/images/sign_inno.png";
import "./base.css";

const Contact_Secret = ({ pdfExportComponent, data, company, company2 }) => {
  return (
    <>
      <div id="document-box" className="documents">
        <PDFExport ref={pdfExportComponent} forcePageBreak=".page-break">
          <div id="page1" style={{ position: "absolute", top: "0%" }}>
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "absolute",
                  top: "0%",
                  right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
            <div
              id="content"
              style={{
                zIndex: 2,
              }}
            >
              <div
                id="header"
                className="text-with-bold"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  //26px
                  top: "120px",
                  right: "47px",
                  fontSize: "18.2px",
                  width: "705px",
                  // fontFamily: "angsaBold",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                <u>
                  <b className="docs-font-bold">สัญญารักษาความลับทางการค้า</b>
                </u>
              </div>
              <div
                id="date"
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "174px",
                  right: "74px",
                  fontSize: "18.2px",
                  width: "650px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                สัญญานี้ทำขึ้นที่บริษัท {company.name_th}
                เมื่อวันที่................เดือน..................................พ.ศ...................
              </div>
              <div
                id="paragraph1"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "204px",
                  right: "74px",
                  fontSize: "18.2px",
                  // fontFamily: "angsaLight",
                  width: "655px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "25px",
                }}
              >
                &nbsp;&emsp;&emsp;&emsp;ข้าพเจ้า............................................................................................................
                อายุ ................ปี อยู่บ้านเลขที่ ....................
                หมู่ที่.................
                ซอย...................................................ถนน...................................................
                ตำบล/แขวง..............................................
                อำเภอ/เขต..............................................จังหวัด.............................................โทรศัพท์............................................ซึ่งต่อไปในสัญญานี้จะเรียกว่า
                &nbsp;&nbsp;“พนักงาน”&nbsp; ขอทำหนังสือฉบับนี้ให้ไว้แก่บริษัท
                &nbsp;{company.name_th}&nbsp; &nbsp;(“บริษัทฯ”)&nbsp;
                เพื่อเป็นการแสดงว่า&nbsp;&nbsp; พนักงาน
                รับทราบและตกลงตามข้อกำหนดต่างๆในสัญญาฉบับนี้
                ตามรายละเอียดดังต่อไปนี้
                <br />
                &nbsp;&emsp;&emsp;ตามที่บริษัทฯได้รับพนักงานเข้าทำงานในตำแหน่ง...............................................................................................................
                แผนก/ฝ่าย...................................................................................................................เนื่องด้วย
                การรักษาความปลอดภัยข้อมูลความลับ
                รวมทั้งความลับทางการค้าเป็นเรื่องที่มีความสำคัญ
                การเปิดเผยข้อมูลจากภายในหรือภายนอกองค์กรไม่ว่าจะเป็นการกระทำโดยเจตนาหรือไม่เจตนาก็ตามอาจส่งผลกระทบกับการดำเนินงานของบริษัทฯ
                ดังนั้นเพื่อให้เกิดความปลอดภัย
                และความเป็นระเบียบเรียบร้อยของการเปิดเผยข้อมูลความลับทางการค้า
                และข้อมูลความลับของบริษัทฯ พนักงาน
                รับทราบและตกลงปฏิบัติตามข้อกำหนดดังต่อไปนี้
                <br />
                <p />
                &nbsp;&emsp;&emsp;&emsp;ข้อ 1.
                <u className="docs-font">คำนิยาม</u>
                <br />
                <p />
                &nbsp;&emsp;&emsp;&emsp;คำว่า “ข้อมูล”
                ให้หมายความถึงแต่ไม่จำกัดเฉพาะ สิ่งที่สื่อความหมายให้รู้ข้อความ
                เรื่องราว ข้อเท็จจริง หรือสิ่งใด ไม่ว่า
                การสื่อความหมายนั้นจะผ่านวิธีการใดๆและไม่ว่าจะจัดทำไว้ในรูปแบบใดๆโดยให้หมายความรวมถึงสูตร
                รูปแบบ งานที่ได้รวบรวมหรือประกอบขึ้น โปรแกรม วิธีการ เทคนิค
                หรือกรรมวิธีด้วย
                ทั้งนี้ไม่ว่าจะมีวัตถุประสงค์จะให้เป็นความลับหรือไม่ก็ตาม
                โดยให้หมายความรวมถึงข้อมูลที่ยังไม่ได้มีการเปิดเผยต่อประชาชน
                ข้อมูลที่มีไว้ใช้เพื่อวัตถุประสงค์ของบริษัทฯอย่างเดียว
                รวมตลอดถึงผลิตภัณฑ์ แบบจำลอง ตัวอย่างสินค้า การวางเกณฑ์ต่างๆ
                รายละเอียดของผลิตภัณฑ์ การออกแบบ ภาพถ่าย แบบร่าง กระบวนการผลิต
                วิธีใช้ ข้อมูลทางด้านเทคนิค ข้อมูลทางการค้า รายละเอียดทางเทคนิค
                แผนธุรกิจ ความชำนาญ ประสบการณ์ กลยุทธ์ทางธุรกิจ ปริมาณสินค้า
                ความลับทางการค้า ราคาทุน แหล่งซื้อสินค้า ข้อมูลทางการเงิน
                และการตลาด บันทึก สำเนา รายงาน การวิเคราะห์ และการตรวจสอบ ฯลฯ
                <br />
                <p />
                &nbsp;&emsp;&emsp;&emsp;ข้อ 2.
                <u className="docs-font">
                  การเปิดเผยข้อมูลความลับทางการค้า และข้อมูลของบริษัทฯ
                </u>
                <br />
                <p />
                &nbsp;&emsp;&emsp;&emsp;2.1
                พนักงานจะต้องไม่เปิดเผยข้อมูลความลับทางการค้า
                ข้อมูลความลับทางธุรกิจ
                หรือข้อมูลที่หากเปิดเผยแล้วอาจทำให้เสียประโยชน์
                และความสามารถในการแข่งขันแก่บุคคลภายนอกบริษัทฯ โดยเฉพาะอย่างยิ่ง
                หน่วยงานราชการ สรรพากร นักข่าว นักวิจัย นักวิเคราะห์
                คู่แข่งทางการค้า และนักลงทุนทั่วไป ไม่ว่าจะได้รับโดยเอกสาร อีเมล
                หมายเรียกของราชการ หรือคำสั่ง การขอความอนุเคราะห์
                ขอความร่วมมือใดๆ ก็ตาม
                <br />
                &nbsp;&emsp;&emsp;&emsp;2.2
                พนักงานจะต้องไม่แบ่งปันข้อมูลความลับกับบุคคลอื่นที่ไม่มีส่วนเกี่ยวข้อง
                และจำเป็นต้องทราบ
                แม้ว่าจะเป็นการเปิดเผยข้อมูลระหว่างบุคคลและแผนกต่างๆภายในบริษัทฯ
                ก็ตาม
                <br />
                &nbsp;&emsp;&emsp;&emsp;2.3
                พนักงานรับทราบว่าข้อมูลที่เป็นความลับและต้องได้รับการปกป้องและต้องรักษาให้มีความปลอดภัย
                ได้แก่ ข้อมูลทางการเงิน ความลับทางการค้า ตัวเลขยอดขาย
                ข้อมูลเกี่ยวกับพนักงาน ลูกค้า ผู้จัดหาสินค้า หรือบริการ
                ข้อมูลเกี่ยวกับค่าจ้างและเงินเดือน เงินรางวัลประจำปี แผนการลงทุน
                พยากรณ์ รายได้ แผนปรับปรุงผลิตภัณฑ์ ข้อมูลราคาและกำไร
                ข้อมูลเกี่ยวกับสินค้าในอนาคต การตลาด การโฆษณา
                หรือการเปลี่ยนแปลงผู้บริหาร เป็นต้น
              </div>
            </div>
            <div id="var" className="var">
              {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              <div
                id="date_day"
                className="date day docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "171.5px",
                  right: company.name_th.length >= 18 ? "343px" : "361px",
                  fontSize: "18.2px",
                  width: "45px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_day} 
              </div>

              <div
                id="date_month"
                className="date month docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "171.5px",
                  right: company.name_th.length >= 18 ? "208px" : "241px",
                  fontSize: "18.2px",
                  width: "99px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_month}
              </div>

              <div
                id="date_year"
                className="date year docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "171.5px",
                  right: company.name_th.length >= 18 ? "132px" : "162px",
                  fontSize: "18.2px",
                  width: "53px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_year}
              </div>

              <div
                id="personal_info_name"
                className="personal_info name docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "203.5px",
                  right: "300px",
                  fontSize: "18.2px",
                  width: "327px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_name}
              </div>
              <div
                id="personal_info_age"
                className="personal_info age docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "203.5px",
                  right: "220.6px",
                  fontSize: "18.2px",
                  width: "44px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_age}
              </div>

              <div
                id="personal_info_house_No"
                className="personal_info house_No docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "203.5px",
                  right: "77px",
                  fontSize: "18.2px",
                  width: "57px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_house_No}
              </div>

              <div
                id="personal_info_village_No"
                className="personal_info village_No docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "227.5px",
                  right: "655px",
                  fontSize: "18.2px",
                  width: "49px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_village_No}
              </div>

              <div
                id="personal_info_lane"
                className="personal_info lane docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "227.5px",
                  right: "467px",
                  fontSize: "18.2px",
                  width: "153px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_lane}
              </div>

              <div
                id="personal_info_road"
                className="personal_info road docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "227.5px",
                  right: "286px",
                  fontSize: "18.2px",
                  width: "154px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_road}
              </div>

              <div
                id="personal_info_sub_district"
                className="personal_info sub_district docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "227.5px",
                  right: "76px",
                  fontSize: "18.2px",
                  width: "137px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_sub_district}
              </div>

              <div
                id="personal_info_district"
                className="personal_info district docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "253.5px",
                  right: "535px",
                  fontSize: "18.2px",
                  width: "136px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_district}
              </div>

              <div
                id="personal_info_province"
                className="personal_info province docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "253.5px",
                  right: "362px",
                  fontSize: "18.2px",
                  width: "134px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_province}
              </div>

              <div
                id="personal_info_phone_number"
                className="personal_info phone_number docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "253.5px",
                  right: "184px",
                  fontSize: "18.2px",
                  width: "130px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_phone_number}
              </div>

              <div
                id="detail_position"
                className="detail position docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "329px",
                  right: "75px",
                  fontSize: "18.2px",
                  width: "330px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.detail_position}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "351.5px",
                  right: data?.detail_department?.length >= 49 ? "327px" : "309px", 
                  fontSize: "18.2px",
                  width: "350px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                 {data?.detail_department?.split("_")[1] ||
                  data?.detail_department?.split("_")[0]}
              </div>
            </div>
          </div>

          <div
            id="page2"
            className="page-break"
            style={{
              position: "absolute",
              top: "1150px",
              right: "0%",
              fontFamily: "THSarabun",
            }}
          >
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "relative",
                  // top: "1150px",
                  // right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
              <div
                id="content"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "0px",
                  right: "0px",
                }}
              >
                {" "}
                {company2.head && (
                  <img
                    src={company2.head}
                    style={{
                      position: "absolute",
                      width: "770px",
                      height: "100px",
                      right: "10px",
                      top: "20px",
                      zIndex: 100,
                      boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                    }}
                  />
                )}
                {company2.foot && (
                  <img
                    src={company2.foot}
                    style={{
                      position: "absolute",
                      width: "770px",
                      height: "70px",
                      right: "10px",
                      top: "1060px",
                      zIndex: 100,
                      boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                    }}
                  />
                )}
                <div
                  id="paragraph1"
                  className="docs-font"
                  style={{
                    zIndex: 2,
                    position: "relative",
                    top: "125px",
                    right: "74px",
                    fontSize: "18.2px",
                    // fontFamily: "angsaLight",
                    width: "655px",
                    letterSpacing: 0.14,
                    textAlign: "justify",
                    lineHeight: "25px",
                  }}
                >
                  &nbsp;&emsp;&emsp;&emsp;2.4
                  พนักงานรับทราบว่าบุคคลที่สามารถเปิดเผยข้อมูลความลับของบริษัทฯ&nbsp;
                  &nbsp;คือ &nbsp;นายสุระ&nbsp; คณิตทวีกุล
                  &nbsp;ประธานเจ้าหน้าที่บริหาร&nbsp; แต่เพียงผู้เดียว
                  <br />
                  <p />
                  &nbsp;&emsp;&emsp;&emsp;ข้อ 3.
                  <u className="docs-font">
                    การป้องกันการขัดแย้งของผลประโยชน์ และการเปิดเผยข้อมูลภายใน
                  </u>
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;3.1
                  พนักงานจะต้องหลีกเลี่ยงการทำรายการที่เกี่ยวโยงกับตนเอง
                  ที่อาจก่อให้เกิดความขัดแย้งทางผลประโยชน์กับบริษัทฯ
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;3.2
                  กรณีที่จำเป็นต้องทำรายการนั้น&nbsp;&nbsp;
                  เพื่อประโยชน์ของบริษัทฯ&nbsp;&nbsp;
                  พนักงานจะต้องทำรายการนั้นเสมือนการทำรายการ&nbsp;&nbsp;
                  กับบุคคลภายนอกที่มีข้อตกลงทางการค้าในลักษณะเดียวกับที่วิญญูชนพึงกระทำกับคู่สัญญาทั่วไปด้วยอำนาจต่อรองทางการค้าที่ปราศจากอิทธิพลในการที่เป็นกรรมการ
                  ผู้บริหาร หรือบุคคล ที่เกี่ยวข้อง
                  และต้องไม่มีส่วนในการพิจารณาอนุมัติ
                  และมีหน้าที่ต้องปฏิบัติตามข้อกำหนดของ ตลาดหลักทรัพย์
                  และสำนักงานคณะกรรมการกำกับหลักทรัพย์ และตลาดหลักทรัพย์
                  ในเรื่องการเปิดเผยข้อมูลการทำรายการเกี่ยวโยง
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;3.3
                  กรณีที่เข้าข่ายเป็นรายการที่เกี่ยวโยงกันภายใต้ประกาศของตลาดหลักทรัพย์แห่งประเทศไทย
                  พนักงานจะต้องปฏิบัติตามหลักเกณฑ์
                  &nbsp;&nbsp;วิธีการ&nbsp;&nbsp;
                  และการเปิดเผยข้อมูลรายการที่เกี่ยวโยงกันของบริษัทจดทะเบียนอย่างเคร่งครัด
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;3.4
                  พนักงานจะต้องพิจารณารายการที่มีหรืออาจมีความขัดแย้งทางผลประโยชน์
                  &nbsp;(Conflicts of Interest) &nbsp;ระหว่างผู้ถือหุ้น กรรมการ
                  ผู้บริหาร และบุคคลอื่นที่อาจมีความขัดแย้งอื่น
                  ซึ่งใช้แนวปฏิบัติ อย่างชัดเจน
                  และเชื่อมั่นได้ว่าการเข้าทำรายการดังกล่าวมีความเป็นธรรม
                  โปร่งใส สมเหตุสมผล และเปิดเผยข้อมูลอย่างถูกต้องครบถ้วน
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;3.5
                  ในกรณีที่พนักงานหรือบุคคลในครอบครัว
                  &nbsp;&nbsp;เข้าไปมีส่วนร่วมหรือเป็นผู้ถือหุ้นในกิจการที่แข่งขันกับธุรกิจของบริษัทฯหรือกิจการใดๆ
                  ที่อาจก่อให้เกิดความขัดแย้งทางผลประโยชน์กับบริษัทฯ
                  พนักงานจะต้องแจ้งให้คณะกรรมการบริษัทฯทราบเป็นลายลักษณ์อักษรทันที
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;3.6
                  ระหว่างที่ปฏิบัติงานให้บริษัทฯและหลังจากพ้นสภาพการเป็นพนักงานแล้ว&nbsp;&nbsp;
                  พนักงานจะต้องไม่เปิดเผยข้อมูลที่ถือว่าเป็นความลับของบริษัทฯเพื่อประโยชน์แก่ผู้ใดทั้งสิ้น&nbsp;
                  ไม่ว่าจะเป็นข้อมูลอิเล็กทรอนิกส์ ข้อมูลการเงิน
                  การปฏิบัติงาน&nbsp; ข้อมูลธุรกิจ แผนงานในอนาคตของบริษัทฯ
                  และอื่นๆ
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;3.7 พนักงานต้องดำเนินการแจ้ง
                  &nbsp;ให้กรรมการและผู้บริหารทราบถึงภาระหน้าที่ในการรายงานการถือหลักทรัพย์ใน&nbsp;&nbsp;
                  บริษัทฯ &nbsp;ของตนเอง &nbsp;คู่สมรส&nbsp;&nbsp;
                  และบุตรที่ยังไม่บรรลุนิติภาวะ&nbsp;&nbsp;
                  ตลอดจนรายงานความเปลี่ยนแปลงการถือหลักทรัพย์ต่อสำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์&nbsp;
                  ตามมาตรา &nbsp;&nbsp;59 &nbsp;และบทลงโทษตามมาตรา 275&nbsp;
                  แห่งพระราชบัญญัติหลักทรัพย์&nbsp; พ.ศ. 2535&nbsp;
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;3.8
                  พนักงานพึงหลีกเลี่ยงการให้หรือการใช้ข้อมูลภายในของบริษัทฯ
                  &nbsp;ที่ยังไม่เปิดเผยต่อสาธารณชน&nbsp;&nbsp;
                  อันเป็นสาระสำคัญต่อการเปลี่ยนแปลงราคาหลักทรัพย์ของบริษัทฯไปใช้เพื่อประโยชน์ส่วนตนซึ่งรวมถึงเพื่อการซื้อขายหลักทรัพย์
                  หากบริษัทฯพบว่าพนักงานของบริษัทฯกระทำผิดข้อห้ามนี้บริษัทฯจะพิจารณาดำเนินการตามกฎหมาย
                  <br />
                  <p />
                  &nbsp;&emsp;&emsp;&emsp;ข้อ 4.{" "}
                  <u className="docs-font">การประพฤติผิดสัญญา</u>
                  <br />
                  <p />
                  &nbsp;&emsp;&emsp;&emsp;พนักงานรับทราบว่าหากพนักงานฝ่าฝืนหรือประพฤติผิดสัญญานี้
                  ถือว่าเป็นการประพฤติผิดสัญญาจ้างอย่างร้ายแรงโดยที่พนักงานมีสิทธิพิจารณาลงโทษในขั้นร้ายแรง
                  ตั้งแต่การชำระค่าเสียหายในทางแพ่ง
                  และ/หรือตามคำพิพากษาของศาลที่กำหนดโทษจำคุก ปรับ
                  หรือโทษทางอาญาอื่นๆ รวมถึงรับโทษทางวินัยสูงสุด
                  เช่นการให้ออกจากงาน การระงับจ่ายค่าจ้าง เป็นต้น
                </div>
              </div>
            </div>
          </div>
          <div
            id="page3"
            className="page-break"
            style={{
              position: "absolute",
              top: "2300px",
              right: "0%",
              fontFamily: "THSarabun",
            }}
          >
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "relative",
                  // top: "1150px",
                  // right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
              <div
                id="content"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "0px",
                  right: "0px",
                }}
              >
                <div
                  className="docs-font"
                  id="paragraph1"
                  style={{
                    zIndex: 2,
                    position: "relative",
                    top: "133px",
                    right: "74px",
                    fontSize: "18.2px",
                    // fontFamily: "angsaLight",
                    width: "655px",
                    letterSpacing: 0.14,
                    textAlign: "center",
                    lineHeight: "25px",
                  }}
                >
                  พนักงานได้อ่านและเข้าใจข้อความในสัญญานี้โดยตลอดแล้ว
                  จึงได้ลงลายมือชื่อไว้เป็นสำคัญ&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                  <p />
                  <br />
                  <br />
                  &nbsp;&nbsp;&nbsp;ลงชื่อ....................................................................................นายจ้าง
                  <br />( { company2.name == "Bakery" ? "...................................................................................": "นายคงศักดิ์ บรรณาสถิตย์กุล"}  )<br />
                  <br />
                  &nbsp;&nbsp;&nbsp;ลงชื่อ...................................................................................พนักงาน
                  <br />
                  (...................................................................................)
                  <br />
                  <br />
                  &nbsp;&nbsp;&nbsp;ลงชื่อ...................................................................................พยาน
                  <br />
                  (...................................................................................)
                  <br />
                  <br />
                  &nbsp;&nbsp;&nbsp;ลงชื่อ...................................................................................พยาน
                  <br />
                  (...................................................................................)
                </div>
              </div>
            </div>

            <div id="var" className="var">
              {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
            { company2.name != "Bakery" &&
              <img
                id="sign_inno"
                src={sign_inno}
                alt="sign_inno"
                style={{
                  height: "100px",
                  width: "178px",
                  position: "absolute",
                  top: "150px",
                  right: "275px",
                  zIndex: -5,
                }}
              />
            }
              <div
                id="personal_info_name2"
                className="personal_info name2 docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "305.5px",
                  right: "276px",
                  fontSize: "18.2px",
                  width: "251px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_name}
              </div>
            </div>
          </div>
        </PDFExport>
      </div>
    </>
  );
};

Contact_Secret.propTypes = {
  data: PropTypes.object.isRequired,
  pdfExportComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object }),
  ]),
};

export default Contact_Secret;
